module.exports = __webpack_public_path__ + "static/media/dart_logo.47d021aa.webp";